import React from 'react'
import { FormattedMessage } from 'react-intl'

import { useRoutes } from '../../routes'
import { Button } from '../Button/Button'
import { NavMenuLink } from './NavMenu'

const START_FREE_NAVBAR_ID = 'start-for-free-navbar' //USED IN E2E TESTS

export const NavbarActions = () => {
  const routes = useRoutes()
  return (
    <div className="flexbox flexbox-align-center flexbox-column-gap-8">
      <NavMenuLink href={routes.auth.signin()}>
        <FormattedMessage id="navbar.signIn" defaultMessage="Sign in" />
      </NavMenuLink>
      <Button
        variant="secondary"
        href={routes.bookDemo()}
        className="navbar-secondary-cta"
      >
        <FormattedMessage id="navbar.bookDemo" defaultMessage="Book demo" />
      </Button>
      <Button
        id={START_FREE_NAVBAR_ID}
        variant="primary"
        href={routes.auth.signup()}
      >
        <FormattedMessage
          id="navbar.startForFree"
          defaultMessage="Start for free"
        />
      </Button>
    </div>
  )
}
